import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ConfirmDelete } from './ConfirmDelete';

export const ConfirmDeletePage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(['dream', 'translation']);
  const handleCancelClick = (address: string) => {
    history.replace(`/players/dream/history/detail/${address}`);
  };
  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #f5f1e3;
      `}
    >
      <ConfirmDelete
        title={t('translation:dialog_warning')}
        description={t('dialog_delete_ask_00')}
        confirm={t('dialog_delete_dream_history')}
        onCancelClick={handleCancelClick}
      />
    </div>
  );
};
